import { defineMessages } from 'react-intl'

export default defineMessages({
  customerDataNotComplete: {
    id: 'containers.CustomerPage.CreateOrder.customerDataNotComplete',
    defaultMessage: 'Please complete customer data before creating an order',
  },
  createOrder: {
    id: 'containers.CustomerPage.CreateOrder.createOrder',
    defaultMessage: 'Create order',
  },
  loading: {
    id: 'containers.CustomerPage.CreateOrder.loading',
    defaultMessage: 'Creating...',
  }
})
